export interface CircleMarkerProps {
  id: string;
  color: string;
}

export function CircleMarker({ color, id }: CircleMarkerProps) {
  return (
    <marker
      id={id}
      markerWidth="8"
      markerHeight="8"
      viewBox="-4 -4 8 8"
      orient="auto"
      refX="0"
      refY="0"
    >
      <circle r="3" fill={color} />
    </marker>
  );
}
